import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import PlayerTable from '../layouts/components/player/PlayerTable';
import Toolbar from '../layouts/components/player/Toolbar';
import PlayerItem from '../layouts/components/player/PlayerItem';
import {AlertPlayerObject, BookmakerData, EventsStoredObjects, PlayerSettingsObject, User} from '../@types/response';
import {getBookmakers} from '../store/selectors/getBookmakers';
import {GetInitAction} from '../store/actions/player/GetInitAction';
import {GetActivePlayersAction} from '../store/actions/player/GetActivePlayersAction';
import getClient from '../store/selectors/getClient';
import {getMonitors} from '../store/selectors/player/getMonitors';
import PlayerDetailsModal from '../layouts/components/player/modals/PlayerDetailsModal';
import MarketDetailsModal from '../layouts/components/player/modals/MarketPlayerModal';
import {keySearch, sortEvent} from '../store/utils/playerUtils';
import HidePlayerModal from '../layouts/components/player/modals/HidePlayerModal';
import BookPlayerModal from '../layouts/components/player/modals/BookPlayerModal';
import {getPlayerBooks} from "../store/selectors/player/getBooks";
import {AppDispatch} from "recharts/types/state/store";
import {getFixtures} from "../store/selectors/getFixtures";
import {getSettings} from "../store/selectors/player/getSettings";

const Players: React.FC = () => {

    const dispatch = useDispatch<AppDispatch>();

    const fixtures: EventsStoredObjects = useSelector(getFixtures);
    const monitors: AlertPlayerObject[] = useSelector(getMonitors);
    const bookmakers: BookmakerData = useSelector(getBookmakers);
    const client: undefined | User = useSelector(getClient);
    const books: number[] = useSelector(getPlayerBooks)
    const settings: PlayerSettingsObject = useSelector(getSettings)

    const sortedMonitors = useMemo(() =>
                    [...monitors].sort((a, b) => sortEvent(a, b, fixtures, settings)),
            [monitors, fixtures, settings]
    );

    const [search, setSearch] = useState<string>('')

    const enabledBookmakers: Set<number> = useMemo(() => {
        return new Set(Object.keys(bookmakers)
                .filter((id) => books.includes(parseInt(id)))
                .map((b) => parseInt(b)))
    }, [bookmakers, books])

    useEffect(() => {
        dispatch(GetInitAction(client?.id || ''))
        dispatch(GetActivePlayersAction())
        document.title = 'PLAYER - OddMonitor';
    }, [client, dispatch]);

    if (!Object.keys(bookmakers).length) {
        return <div>
            <div
                    id='toolbar-player'
                    className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'
            >
                <Toolbar
                        search={search}
                        setSearch={setSearch}
                />
            </div>
            <div className='mt-16'>
                <PlayerTable/>
            </div>
            <div>Loading</div>
        </div>
    }

    return <React.Fragment>
        <div id='toolbar-player'
             className='bg-toolbar-bgMain border-b border-toolbar-borderBottom fixed top-0 right-0 flex items-end justify-around w-full z-10'>
            <Toolbar
                    search={search}
                    setSearch={setSearch}/>
        </div>
        <div className='mt-16 mx-4'>
            <PlayerTable>
                {sortedMonitors
                        .filter(monitor => keySearch(search.toLowerCase(), monitor, fixtures[monitor.eventId])
                                && enabledBookmakers.has(monitor.bookmakerId)
                                && (client?.client === null || client?.client === monitor.bookmakerId)
                        )
                        .map((monitor: AlertPlayerObject, idx: number) => (
                                <PlayerItem
                                        alert={monitor}
                                        key={`${monitor.playerId}x${idx}`}
                                        event={fixtures[monitor.eventId]}
                                />
                        ))}
            </PlayerTable>
        </div>
        <PlayerDetailsModal/>
        <MarketDetailsModal/>
        <BookPlayerModal/>
        <HidePlayerModal/>
    </React.Fragment>
}

export default Players;
